import styled from 'styled-components';
import IconDoing from '../IconDoing';

const IconTodo = styled(IconDoing)`
  background-color: #71bad8;
`;

export default IconTodo;
